import {FavoritesEnum} from 'presentation/constants';
import {ServicesTypesEnum} from 'presentation/pages/private/services/types';

import {ShortcutAction} from '../types';

const BOOKING_DRAWER_TYPES: ServicesTypesEnum[] = [
	ServicesTypesEnum.EXAMS,
	ServicesTypesEnum.TELEHEALTH,
	ServicesTypesEnum.ODONTO,
];

type ResolveShortcutActionParams = {
	type: ServicesTypesEnum;
	route?: string;
	hasEndpoint: boolean;
	hasHandleClick: boolean;
	hasFeatureFlag: boolean;
	cachedURL?: string;
	disableCache?: boolean;
};

type ResolveFlaggedActionParams = {
	route?: string;
	hasEndpoint: boolean;
	hasHandleClick: boolean;
	hasVariation: boolean;
};

const isFavoriteDoctorsShortcut = (route: string | undefined, type: ServicesTypesEnum) =>
	route === FavoritesEnum.FAVORITE_DOCTORS && type === ServicesTypesEnum.HEALTH;

const resolveFallbackAction = (hasHandleClick: boolean, route?: string): ShortcutAction => {
	if (hasHandleClick) return {kind: 'custom-click'};
	if (!route) return {kind: 'noop'};

	return {kind: 'navigate', route};
};

const resolveShortcutAction = ({
	type,
	route,
	hasEndpoint,
	hasHandleClick,
	hasFeatureFlag,
	cachedURL,
	disableCache,
}: ResolveShortcutActionParams): ShortcutAction => {
	if (hasFeatureFlag) return {kind: 'check-feature-flag'};

	if (cachedURL && !disableCache) return {kind: 'open-cached-url', url: cachedURL};

	if (hasEndpoint) return {kind: 'fetch-link'};

	if (type === ServicesTypesEnum.HEALTH && route !== FavoritesEnum.FAVORITE_DOCTORS) {
		return {kind: 'open-overbooking'};
	}

	if (BOOKING_DRAWER_TYPES.includes(type)) return {kind: 'open-booking-drawer'};

	return resolveFallbackAction(hasHandleClick, route);
};

const resolveFlaggedAction = ({
	route,
	hasEndpoint,
	hasHandleClick,
	hasVariation,
}: ResolveFlaggedActionParams): ShortcutAction => {
	if (hasEndpoint && !hasVariation) return {kind: 'fetch-link'};

	return resolveFallbackAction(hasHandleClick, route);
};

export {isFavoriteDoctorsShortcut, resolveFlaggedAction, resolveShortcutAction};
